import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
    PolicyProductIdEnum,
    PolicyValidityStatusCodeEnum,
    PurchasedProductInterface,
    RelationInterface,
} from 'outshared-lib';

@Component({
    selector: 'ins-insurance-detail',
    templateUrl: './insurance-detail.component.html',
    styleUrls: ['./insurance-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsuranceDetailComponent {
    @Input() public purchasedProduct!: PurchasedProductInterface;
    @Input() public relation!: RelationInterface;

    public productIdEnum = PolicyProductIdEnum;

    public get isBicycle(): boolean {
        return this.purchasedProduct.productId === PolicyProductIdEnum.Bicycle;
    }

    public get isCar(): boolean {
        return this.purchasedProduct.productId === PolicyProductIdEnum.Car;
    }

    public get isCaravan(): boolean {
        return this.purchasedProduct.productId === PolicyProductIdEnum.Caravan;
    }

    public get isHome(): boolean {
        return this.purchasedProduct.productId === PolicyProductIdEnum.Home;
    }

    public get isMoped(): boolean {
        return this.purchasedProduct.productId === PolicyProductIdEnum.Moped;
    }

    public get isMotorcycle(): boolean {
        return this.purchasedProduct.productId === PolicyProductIdEnum.Motorcycle;
    }

    public get isPet(): boolean {
        return this.purchasedProduct.productId === PolicyProductIdEnum.Pet;
    }

    public get hasInternationalMotorInsuranceCard(): boolean {
        const productIds = [
            PolicyProductIdEnum.Car,
            PolicyProductIdEnum.Motorcycle,
            PolicyProductIdEnum.Moped,
            PolicyProductIdEnum.Caravan,
        ];

        // If NOT includes
        if (!productIds.includes(this.purchasedProduct.productId)) {
            return false;
        }

        // If NOT includes
        return ![PolicyValidityStatusCodeEnum.Ended].includes(this.purchasedProduct.product.validityStatusCode);
    }

    public get hasRegularDriver(): boolean {
        return [
            PolicyProductIdEnum.Car,
            PolicyProductIdEnum.Moped,
            PolicyProductIdEnum.Motorcycle,
            PolicyProductIdEnum.Bicycle,
        ].includes(this.purchasedProduct?.productId);
    }

    public get hasPremiumDeterminingFactors(): boolean {
        return Boolean(
            this.purchasedProduct?.productDetails &&
                this.purchasedProduct?.productDetails?.premiumDeterminingFactor &&
                this.purchasedProduct?.productDetails?.premiumDeterminingFactor.length
        );
    }
}
